/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import toNumber from 'lodash/toNumber';
import * as MapHelper from 'shared-ui/maps/helpers/mapHelper';
import { getMapIcon } from 'shared-ui/maps/helpers/utils';
import { featureCollection } from 'shared-ui/maps/turfUtils';

import { getItemDescription } from './tripUtils';

export function getFeature(asset) {
    const feature = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [asset.longitude, asset.latitude],
        },
        properties: {
            name: asset.name,
            title: asset.title,
            id: asset.entityId,
            featureId: asset.featureId,
            icon: asset.mapIcon,
            entityId: asset.entityId,
            entityType: asset.entityType,
            entity_type: asset.entity_type,
            shortDescription: getItemDescription(asset),
            reservable: asset.reservable,
            imageTitle: asset.imageTitle,
            imageUrl: asset.imageUrl,
            location: asset.location,
            recAreaName: asset.recarea_name,
            targetUri: asset.targetUri,
            rate: asset.rate,
            availability: asset.availability,
            availability_counts: asset.availability_counts,
            campsitesCount: asset.campsitesCount,
            average_rating: asset.average_rating,
            number_of_ratings: asset.number_of_ratings,
            toursCount: asset.toursCount,
            org_id: asset.org_id,
            org_name: asset.org_name,
            parent_id: asset.parent_id,
            parent_name: asset.parent_name,
            parent_type_name: asset.parent_type_name,
            campsite_type_of_use: asset.campsite_type_of_use,
            activities: asset.activities,
            city: asset.city,
            state_code: asset.state_code,
            country_code: asset.country_code,
            type: asset.type,
        },
    };

    return feature;
}

export function convertLocationToGEOJsonFeature(location) {
    let feature = null;

    if ((location.longitude && location.latitude) || (location.lng && location.lat)) {
        const asset = { attributes: [] };
        asset.name = location.name;
        asset.title = location.name;
        asset.mapIcon = getMapIcon(location);
        asset.entityId = location.entity_id;
        asset.entityType = location.entity_type;
        asset.entity_type = location.entity_type;
        asset.featureId = `${location.entity_type}_${location.entity_id}`;
        if (location.longitude && location.latitude) {
            asset.longitude = toNumber(location.longitude);
            asset.latitude = toNumber(location.latitude);
        }
        if (location.lng && location.lat) {
            asset.longitude = toNumber(location.lng);
            asset.latitude = toNumber(location.lat);
        }
        asset.description = location.description;
        asset.reservable = location.reservable === true;
        asset.targetUri = MapHelper.getTargetUri(location);
        asset.availability = location.availability;
        asset.availability_counts = location.availability_counts;
        asset.campsitesCount = location.campsites_count;
        asset.toursCount = location.tours_count;
        asset.average_rating = location.average_rating;
        asset.number_of_ratings = location.number_of_ratings;
        asset.org_id = location.org_id;
        asset.org_name = location.org_name;
        asset.parent_id = location.parent_id;
        asset.parent_name = location.parent_name;
        asset.parent_type_name = location.parent_type_name;
        asset.campsite_type_of_use = location.campsite_type_of_use;
        asset.activities = location.activities;
        asset.city = location.city;
        asset.state_code = location.state_code;
        asset.country_code = location.country_code;
        asset.type = location.type;

        if (location.recarea_name && location.recarea_name.length > 0) {
            asset.recarea_name = location.recarea_name[0];
        } else {
            asset.recarea_name = 'No Name';
        }

        if (location.rate && location.rate.prices && location.rate.prices.length > 0) {
            if (location.rate.prices[0].amount) {
                asset.rate = location.rate.prices[0].amount;
            }
        }

        if (location.preview_image_url) {
            asset.imageUrl = location.preview_image_url;
            asset.imageTitle = 'Preview Image';
        }

        if (location.city) {
            asset.location = location.city;
        }

        if (location.state_code) {
            if (asset.location) {
                asset.location = `${asset.location}, ${location.state_code}`;
            } else {
                asset.location = location.state_code;
            }
        }

        feature = getFeature(asset);
    }

    return feature;
}

export function convertSearchResultsToGEOJson(results) {
    const geoJSON = {
        type: 'FeatureCollection',
        features: [],
    };

    results.forEach((location) => {
        const feature = convertLocationToGEOJsonFeature(location);

        if (feature !== null) {
            geoJSON.features.push(feature);
        }
    });
    return geoJSON;
}

export function convertTripItemsToGeojson(destinations) {
    let features = [];
    if (destinations?.length) {
        features = destinations
            .reduce((items, destination) => {
                if (destination?.items?.length) return [...items, ...destination.items];
                return items;
            }, [])
            .map((item) => convertLocationToGEOJsonFeature(item));
    }
    return featureCollection(features);
}
